import React, { Fragment } from "react";
import { projects } from "./helper";
import Break from "../../components/Break";
import ProjectCard from "../../components/Cards/ProjectCard";

const ProjectFallback = (): JSX.Element =>
(
    <>
        {
            projects.map((proj, i) =>
            (
                <Fragment key={i}>
                    <Break />
                    <ProjectCard
                        title={proj.title}
                        image={proj.image}
                        description={proj.description}
                        alt={proj.title}
                        link={proj.link} />

                </Fragment>
            ))
        }
    </>
)
export default ProjectFallback